import { PayloadAction } from "@reduxjs/toolkit";
import { ItemId } from "../../../../utl/models/ItemId";
import { LocationsState } from "../models/LocationsState";

const setNewItemId = (state: LocationsState, action: PayloadAction<ItemId>) => {
    state.newItemId = action.payload.id;
}

export default setNewItemId;